module.exports = {
  'apiUrl': process.env.NODE_ENV === 'production' ? 'https://core.api.enkeldrift.no' : 'https://core.api.enkeldrift.no',
  'deviceApiUrl': process.env.NODE_ENV === 'production' ? 'https://device-service.api.enkeldrift.no' : 'https://device-service.api.enkeldrift.no',
  // apiUrl: 'http://localhost:4000',
  // 'deviceApiUrl': 'http://localhost:4001',
};